import React from 'react';
import { NavLink, Routes, Route } from 'react-router-dom';
import LeadsPage from './pages/LeadsPage';
import LeadDetailPage from './pages/LeadDetailPage';
import WebhooksPage from './pages/WebhooksPage';
import './styles.css';

export default function LeadManagementPage() {
  return <section className="cb-lead-module">
    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
      <div><div className="small text-primary fw-semibold">CHATBIZZ / SALES</div><h1 className="h3 mb-0">Lead Management</h1></div>
      <nav className="d-flex gap-2" aria-label="Lead management sections">
        <NavLink end to="/leads" className={({isActive}) => `btn btn-sm ${isActive ? 'btn-primary' : 'btn-outline-primary'}`}>Leads</NavLink>
        <NavLink to="/leads/webhooks" className={({isActive}) => `btn btn-sm ${isActive ? 'btn-primary' : 'btn-outline-primary'}`}>Webhooks</NavLink>
      </nav>
    </div>
    <Routes>
      <Route index element={<LeadsPage />} />
      <Route path=":id" element={<LeadDetailPage />} />
      <Route path="webhooks" element={<WebhooksPage />} />
    </Routes>
  </section>;
}
